// Teclado em Mesas (dono, 26/10/2026: "o fluxo de Enter e Esc deve funcionar
// nas mesas", igual às Comandas). `acoes` é um ref atualizado a cada render da
// página (estado de agora, sem re-registrar o ouvinte):
//   { aberta, cart, mesas, foco, setFoco, abrir, voltar, enviar, pagarDentro, pagarMesa }
//
// Lista de mesas: setas andam entre as mesas (destaque), Enter abre a mesa
//   destacada, Espaço abre o pagamento dela, Esc tira o destaque.
// Mesa aberta: Enter envia o carrinho (passa pela Conferência) ou, sem
//   carrinho, minimiza; Espaço abre o pagamento; Esc volta (com carrinho,
//   pergunta antes — a pergunta que já existia).
// Com janela aberta (Conferência, pagamento, popup do produto…) a tecla é dela;
// digitando num campo, Enter, Espaço e setas são do campo.
import { useEffect } from "react";

import { SETAS, vizinho } from "./grade";

const caixasDaTela = () => [...document.querySelectorAll("[data-mesa-nav]")].map((el) => {
  const r = el.getBoundingClientRect();
  return { id: el.getAttribute("data-mesa-nav"), x: r.left, y: r.top, w: r.width, h: r.height };
});

export function useTecladoMesas(acoes) {
  useEffect(() => {
    const tecla = (e) => {
      if (e.defaultPrevented || e.repeat || e.ctrlKey || e.altKey || e.metaKey) return;
      if (document.querySelector("[role=dialog], [role=alertdialog], [role=menu]")) return;
      const a = acoes.current;
      if (!a) return;
      const digitando = e.target?.closest?.("input, textarea, select, [contenteditable=true]");

      if (a.aberta) {
        if (e.key === "Escape" && !digitando) { e.preventDefault(); a.voltar(); return; }
        if (digitando) return;
        if (e.key === "Enter") { e.preventDefault(); if (a.cart.length) a.enviar(); else a.voltar(); }
        else if (e.key === " ") { e.preventDefault(); a.pagarDentro(); }
        return;
      }

      if (digitando) return;
      if (SETAS.includes(e.key)) {
        e.preventDefault();
        const destino = vizinho(caixasDaTela(), a.foco, e.key);
        if (destino) {
          a.setFoco(destino);
          document.querySelector(`[data-mesa-nav="${destino}"]`)?.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
        return;
      }
      const mesa = a.foco ? (a.mesas || []).find((m) => String(m.id) === String(a.foco)) : null;
      if (e.key === "Enter") {
        e.preventDefault();
        if (mesa) a.abrir(mesa);
        else { const primeira = caixasDaTela()[0]; if (primeira) a.setFoco(primeira.id); }
      } else if (e.key === " " && mesa) {
        e.preventDefault();
        a.pagarMesa(mesa);
      } else if (e.key === "Escape" && a.foco) {
        a.setFoco(null);
      }
    };
    window.addEventListener("keydown", tecla);
    return () => window.removeEventListener("keydown", tecla);
  }, [acoes]);
}
